import { h4Style, h6Style, tagStyle } from "@/data/styles"
import { Project, RecursiveTranslations } from "@/data/types"
import { formatPrice } from "@/utils/helpers"
import clsx from "clsx"
import Image from "next/image"
import backdrop from '@/assets/images/project-placeholder.svg'

interface ProjectComponentProps  {
  data: Project
  translations: RecursiveTranslations
}

export const ProjectCard = ({ data, translations }: ProjectComponentProps) => {
  return(
    <div className="flex flex-col gap-[10px] text-[#302E2D] w-full group animate-fade-in-up transition-all duration-500 ease-out hover:-translate-y-2">
      <div className="relative w-full aspect-square rounded-[4px] flex justify-center items-center overflow-hidden bg-[#EBE1D4]">
        {data.features && data.features.length > 0 && (
          <div className="absolute top-[16px] flex flex-wrap gap-x-[5px] gap-y-[11px] z-10 px-[17px] w-full">
            {data.features.map((feature, i) => (
              <span key={i} className={clsx(tagStyle, "bg-[#FBFAF9]/80 text-[#1B1D2B] px-[10px] rounded-[10px]")} >
                {feature}
              </span>
            ))}
          </div>
        )}
        <Image src={data?.image || backdrop} alt={data?.title ?? "Project image"} fill/>
      </div>

      <div> 
        <h4 title={data.title} className={clsx(h4Style, "mb-[5px] truncate")}>{data.title}</h4>
        <div>
          <p title={data.specific_address} className={clsx(h6Style, "text-[#6a6867] truncate")}>{data.specific_address}</p>
          <p className={h6Style}>{translations?.from as string} {formatPrice(Number(data?.starting_price))} {data?.currency}</p>
        </div>
      </div>
    </div>
  )
}